import { createContext, useContext } from 'react'
import type { WllTheme } from './types'

export const ThemeContext = createContext<{
	theme: WllTheme | null
	mode: 'light' | 'dark'
}>({
	mode: 'light',
	theme: null,
})

/**
 * A React hook that provides access to the current theme object.
 *
 * This hook retrieves the current theme from the ThemeContext, which is expected
 * to be defined and provided higher in the component tree.
 *
 * @return {WllTheme | null} The current theme object if ThemeContext is available, or null if not.
 */
export function useTheme(): WllTheme | null {
	return useContext(ThemeContext).theme
}

/**
 * A React hook that provides access to the current theme mode ('light' or 'dark').
 *
 * @return {'light' | 'dark'} The current theme mode.
 */
export function useThemeMode(): 'light' | 'dark' {
	return useContext(ThemeContext).mode
}
